import { getActiveEvents } from './getActiveEvents'
import { getActiveTypeticketcollections } from './getActiveTypeTicketCollections'
import { getBulkData } from './getBulkData'
import { getBusySeats } from './getBusySeats'
import { getData } from './getData'
import { getEvents } from './getEvents'
import { getSectionsEnabled } from './getSectionsEnabled'
import { getTypeTickets } from './getTypeTickets'

export const CollectionController = {
  getBusySeats,
  getSectionsEnabled,
  getTypeTickets,
  getData,
  getEvents,
  getBulkData,
  getActiveEvents,
  getActiveTypeticketcollections,
}
